{
    "contours": {
        "basePath": ""
    },
    "elevation": {
        "urlTemplate": "/terra512/{z}/{x}/{y}.img"
    },
    "arcgis": {
        "attribution": "ArcGIS Online",
        "apikey": "",
        "urlTemplate": "https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
    },
    "osm": {
        "attribution": "Open Street Maps",
        "apikey": "",
        "urlTemplate": "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
    },
    "geocoder": {
        "apikey": "TOP-SECRET-2"
    },
    "hikesnearme": {
        "baseUrl": "/hikesnearme"
    }
}
